import { Text } from "@mantine/core"
import { ActivityTypeText } from "../../art/activities/-components/activity-type-text"
import { ellipsify } from "../../../../utils/ellipsify"

export interface ActivityTitleTextProps {
  type: string
  title: string
  rehearseNumber?: number | null
  isPublic: boolean
  artisticNote?: string
  technicalNote?: string
  location: string
  foreColor?: string
  backColor?: string
}

export function ActivityTitleText({
  type,
  title,
  rehearseNumber,
  isPublic,
  artisticNote,
  technicalNote,
  location,
  foreColor,
  backColor,
}: ActivityTitleTextProps) {
  return (
    <Text inline span flex="1 2 40%" style={{ ...ellipsify }}>
      {!!type && (
        <ActivityTypeText
          span
          name={type}
          rehearseNumber={rehearseNumber}
          backColor={backColor}
          foreColor={foreColor}
        />
      )}
      <Text fw={isPublic ? "bold" : undefined} span>
        {isPublic ? ` ${title.toUpperCase()}` : ` ${title}`}
      </Text>
      <Text span>{location ? ` (${location})` : null}</Text>
      {artisticNote || technicalNote ? (
        <Text c="dimmed">
          {artisticNote ? artisticNote + " " : null}
          {technicalNote ? technicalNote : null}
        </Text>
      ) : null}
    </Text>
  )
}
